<template>
  <Select
    :value="id"
    @on-select="ddddd"
    :clearable="clearable"
    @on-clear="clear"
  >
    <Option v-for="(x, index) in wanggeList" :value="x.id" :key="index">{{
      x.name
    }}</Option>
  </Select>
  
</template>
<script>
import axios from "axios"
export default {
  props: ["id","clearable"],
  data() {
    return {
      wanggeList: [],
    };
  },
  methods: {
    ddddd(v) {
      this.$emit("update:id", v.value);
      this.$emit("update:name", v.label);
    },
    clear(v) {
      this.$emit("update:id", "");
      this.$emit("update:name", "");
    },
    getWange() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.swm + "/grid/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        this.wanggeList = data;
      });
    },
  },
  mounted() {
    this.getWange();
  },
};
</script>




// WEBPACK FOOTER //
// src/components/common/selectGrid.vue